export const css = {
	root: 'pXIigxic',
	content: 'nohjX3-d',
	title: 'KxZZlc3W',
	subtitle: 'PecUMAbe',
	actions: 'erbRVPjb',
	' _key': 'card/general'
};

export default css;
